<template>
  <Typography tag="td" color="gray800">
    <div class="break-wrapper">
      <div class="break-item">
        <typography color="secondary" class="pl-6" weight="600" transform="uppercase"
          >Break Time / Unavailable</typography
        >
        <v-btn
          :disabled="archived"
          color="secondary"
          variant="text"
          icon
          size="small"
          v-if="authStore.me.set_breaks || authStore.me.modify_schedule"
          @click="deleteSchedule"
          :loading="state.loading"
        >
          <v-icon color="secondary">mdi-trash-can-outline</v-icon>
        </v-btn>
      </div>
    </div>
  </Typography>
  <td v-if="showComments"></td>
  <td v-if="noShow"></td>
</template>

<script setup lang="ts">
import type { GetSchedule } from "@/api_types/teacher";
import FetchService from "@/services/fetch.service";
import { useAuthenticationStore } from "@/stores/authentication";
import { reactive } from "vue";
import Typography from "../typography.vue";

const authStore = useAuthenticationStore();

const props = defineProps<{
  agenda: GetSchedule;
  reload: () => any;
  delete: () => any;
  noShow: boolean;
  showComments: boolean;
  archived: boolean;
}>();

const state = reactive({
  loading: false
});

const deleteSchedule = async () => {
  state.loading = true;
  const resp = await FetchService.fetchData("/schedule/" + props.agenda.pta_id, "delete");
  if (resp) {
    props.delete();
  } else {
    props.reload();
  }
  state.loading = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.break-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .break-item {
    min-height: 45px;
    background-color: $secondary-50;
    border: 1px solid $secondary;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    padding: 0 10px;
  }
}
</style>
